import React, {useCallback, useEffect, useRef, useState} from "react";
import NotificationIcon from "./Notificacoes";
import axios from "axios";
import { Popover } from "antd";
import moment from "moment/moment";





export default function PopoverNotificacoes({abrirTodas}) {
    const [notificacoes, setNotificacoes] = useState([]);
    const [pagina, setPagina] = useState(1);
    const [temMais, setTemMais] = useState(true);
    const [loading, setLoading] = useState(false);
    const [totalPorLer, setTotalPorLer] = useState(0);
    const [open, setOpen] = useState(false);
    
    const observer = useRef();

    const Notificacao = notificacao => {
        return (
            <div className="notificacao popover">
                <div className={` ${notificacao.lido ? "read-text" : ""}`}>
                    <div className="info">
                        <span className="title">{notificacao.titulo}</span>
                        <span className="description">{notificacao.descricao}</span>
                    </div>
                    <div>
                        <span className="tempo">{tempoDecorrido(notificacao.dt_criado)}</span>
                    </div>
                </div>

                {notificacao.read && <div className="read"></div>}
            </div>
        );
    };

    const tempoDecorrido = date => {
        const agora = new Date();
        const criado = new Date(date);
        const diffHoras = Math.floor((agora - criado) / (1000 * 60 * 60));

        if (diffHoras < 1) return "agora";
        if (diffHoras < 24) return `Há ${diffHoras} horas atrás`;
        return moment(date).format("DD MMM YYYY");
    };

    const lastElementRef = useCallback(
        (node) => {
            if (loading) return;

            if (observer.current) {
                observer.current.disconnect();
            }

            observer.current = new IntersectionObserver((entries) => {
                if (loading || !temMais) return;
                if (entries[0].isIntersecting && temMais  && !loading) {
                    setPagina((prev) => prev + 1);
                }
            });

            if (node) {
                observer.current.observe(node);
            }
        },
        [loading, temMais]
    );

    const getNotificacoes = (pag) => {
        if (loading) return;
        setLoading(true);

        axios({
            method: "get",
            url: "api/notificacoes/listar",
            params: { pagina: pag },
            timeout: 60 * 10 * 1000
        })
            .then(response => {
                const novas = response.data.dados;
                setNotificacoes(prev => pag === 1 ? novas : [...prev, ...novas]);
                setTotalPorLer(response.data.totalPorLer);
                setTemMais(response.data.totalPaginas > pag );
                
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                if (error.response?.status === 401) {
                }
            }) 
    };

    const marcarComoLido = (ids) => {
        axios({
            method: "POST",
            url: "api/notificacoes/marcar-como-lido",
            data: ids
        })
            .then(() => {
                getNotificacoes(1);
            })
            .catch(error => {
                if (error.response?.status === 401) {
                }
            });
    };

    useEffect(() => {
        getNotificacoes(pagina);
    }, [pagina]);
    
    return (
        <Popover
            getPopupContainer={() => document.body}
            overlayStyle={{ position: "fixed" }}
            content={
                <div className="notificacoes-nav" style={{width:320}}>
                    {notificacoes.length === 0 && !loading && (
                        <div className="sem-notificacoes">
                            <span>Sem notificações</span>
                        </div>
                    )}

                    {notificacoes.map((n, index) => {
                        const isLast = notificacoes.length === index + 1;

                        return (
                            <div
                                key={n.id}
                                ref={isLast ? lastElementRef : null}
                            >
                                {Notificacao(n)}
                            </div>
                        );
                    })}
                    
                    {loading && (
                        <div className="py-2 text-center">
                            A carregar...
                        </div>
                    )}
                    {!temMais &&
                        notificacoes.length > 0 && (
                            <div className="sem-notificacoes">
                                <span>Sem mais notificações</span>
                            </div>
                        )}
                </div>
            }
            title={
            <div className={"header-popover-notificacoes"}>
                <span style={{ fontSize: 18, fontWeight: 500, cursor:"pointer" }}>Notificações</span>
                <div>
                        <span
                            style={{cursor: "pointer"}}
                            onClick={() => {
                                 setOpen(false); // fecha diretamente, sem passar pelo pai
                                 abrirTodas();
                            }}
                        >
                            Ver Todas
                        </span>
                </div>
            </div>}
            trigger="click"
            visible={open}
            onVisibleChange={(visible) => {
                setOpen(visible);
                setPagina(1)
                if (!visible) {
                    marcarComoLido(
                        notificacoes.map(n => n.id));
                }
            }}
            placement="bottomRight"
        >
            <NotificationIcon count={totalPorLer} onClick={() => {}} />
        </Popover>
    );
}